module.exports = __webpack_public_path__ + "images/ca50506ba6296a08b5f1c905d4cb3fb7.png";